<template>
  <div class="dx-container">
    <van-question-steam
      v-if="!(exercise.image === '' && !exercise.title && ((isDone && isExam) || isPrint))"
      :exercise="exercise"></van-question-steam>
    <div class="exercise-body">
      <p class="question">
        <span v-if="isShowNumber">{{index + 1}}、</span>
        <span v-html="exercise.question"></span>
        <span
          v-if="isExam && isDone && (!userAnswer || userAnswer.answer === -1)"
          class="wrong">（未作答）</span>
      </p>
      <div class="radio-wrapper">
        <van-option
          v-for="(option, index) in formatOptions"
          :key="index"
          :index="index"
          :isToggleStyle="isExam && isDone"
          :option="option"
          :answer="rightAnswer"
          @click.native="selectOption(option)"
          :is-done="isDone"
          :is-activate="exercise.options[selectedOptionIndex] === option"
          ></van-option>
      </div>
      <p v-if="isDone && exercise.explain && isShowExplain" class="explain">
        <strong>解析：</strong>
        <span v-html="exercise.explain"></span>
      </p>
    </div>
  </div>
</template>

<script>
import VanQuestionSteam from '@/components/common/QuestionSteam.vue';
import VanOption from './DXOption.vue';

export default {
  name: 'DX',
  components: {
    VanQuestionSteam,
    VanOption,
  },
  props: {
    exercise: {
      type: Object,
      required: true,
    },
    isDone: {
      type: Boolean,
    },
    isExam: {
      type: Boolean,
    },
    isPrint: {
      type: Boolean,
      default: false,
    },
    isShowExplain: {
      type: Boolean,
      default: false,
    },
    isShowNumber: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
    },
    userAnswer: {
      type: Object,
    },
    isBacktrack: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isActivate: false,
      selectedOptionIndex: -1,
      isComplete: false,
      formatOptions: [],
      rightAnswer: '',
    };
  },
  watch: {
    exercise() {
      if (this.isExam && this.userAnswer && this.userAnswer.answer >= 0) {
        this.selectedOptionIndex = this.userAnswer.answer;
      } else {
        this.selectedOptionIndex = -1;
      }
    },
  },
  created() {
    this.initExercise();
  },
  methods: {
    initExercise() {
      if ((this.isExam || this.isBacktrack) && this.userAnswer && this.userAnswer.answer >= 0) {
        this.selectedOptionIndex = this.userAnswer.answer;
      }
      this.rightAnswer = this.exercise.options[this.exercise.answerIndex];
      if (this.exercise.formatOptions && this.isExam) {
        this.formatOptions = this.exercise.formatOptions;
      } else {
        if (this.isPrint) {
          this.formatOptions = this.exercise.options;
          return;
        }
        this.formatOptions = [...this.exercise.options].sort(() => 0.5 - Math.random());
        this.$emit('changeOption', {
          formatOptions: this.formatOptions,
        });
      }
    },
    selectOption(option) {
      if (this.isDone) return;
      if (this.isPrint) return;
      const index = this.exercise.options.indexOf(option);
      const isRight = this.rightAnswer === option;
      this.selectedOptionIndex = index;
      this.isComplete = true;
      this.$emit('change', {
        id: this.exercise.id,
        answer: index,
        isRight: isRight || false,
        formatOptions: this.formatOptions,
        isComplete: this.isComplete,
      });
    },
  },
};
</script>

<style lang="scss">
  @import '@/styles/variables.scss';
  .dx-container {
    margin-top: 10px;
    .exercise-body {
      padding: 0 30px;
      font-size: 18px;
      .question {
        margin: 10px 0;
        line-height: 1.4;
      }
      .radio-wrapper {
        width: 100%;
        box-sizing: border-box;
        padding-left: 15px;
        display: flex;
        flex-wrap: wrap;
      }
      .explain {
        margin-top: 0;
        padding-left: 10px;
        line-height: 1.6;
      }
      .wrong {
        color: $danger;
      }
    }
  }
</style>
